<template lang="">
  <div class="styled-form">
    <div class="formgrid grid">
      <div class="field col-12">
        <label class="label-input-rounded" for="name">{{
          $t("profile.name")
        }}</label
        ><br />
        <input
          autocomplete="off"
          v-model="v$.name.$model"
          :class="{ invalid: v$.name.$invalid && v$.name.$dirty }"
          class="inputtext component input-rounded"
          id="name"
          type="text"
        />
        <span v-if="v$.name.$invalid && v$.name.$dirty" class="error">{{
          $t("form.required_field")
        }}</span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <label class="label-input-rounded" for="surname">{{
          $t("profile.surname")
        }}</label
        ><br />
        <input
          v-model="v$.surname.$model"
          :class="{ invalid: v$.surname.$invalid && v$.surname.$dirty }"
          class="inputtext component input-rounded"
          id="surname"
          type="text"
        />
        <span v-if="v$.surname.$invalid && v$.surname.$dirty" class="error">{{
          $t("form.required_field")
        }}</span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <label class="label-input-rounded" for="email">Email</label><br />
        <input
          autocomplete="off"
          v-model="v$.email.$model"
          :class="{ invalid: v$.email.$invalid && v$.email.$dirty }"
          class="inputtext component input-rounded"
          id="email"
          type="text"
        />
        <span
          v-if="v$.email.required.$invalid && v$.email.$dirty"
          class="error"
          >{{ $t("form.required_field") }}</span
        >
        <span v-if="v$.email.email.$invalid && v$.email.$dirty" class="error">{{
          $t("form.invalid_format")
        }}</span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <label class="label-input-rounded" for="dob">{{
          $t("family_member.birthday")
        }}</label
        ><br />
        <Calendar
          id="date"
          v-model="v$.dob.$model"
          :class="{ invalid: v$.dob.$invalid && v$.dob.$dirty }"
          class="inputtext component input-rounded"
          :showIcon="true"
        /><br />

        <span v-if="v$.dob.required.$invalid" class="error">{{
          $t("form.required_field")
        }}</span>
      </div>
    </div>
    <div class="formgrid grid">
      <div class="field col-12">
        <label class="label-input-rounded" for="relation">{{
          $t("family_member.relation")
        }}</label
        ><br />
        <input
          autocomplete="off"
          v-model="v$.relation.$model"
          :class="{ invalid: v$.relation.$invalid && v$.relation.$dirty }"
          class="inputtext component input-rounded"
          id="relation"
          type="text"
        />
        <span v-if="v$.relation.$invalid && v$.relation.$dirty" class="error">{{
          $t("form.required_field")
        }}</span>
      </div>
    </div>
    <div class="mt-5 grid">
      <div class="col text-right">
        <Button @click="save()" :label="$t('form.submit_label')" />
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapFields } from "vuex-map-fields";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {};
  },
  validations() {
    return {
      name: {
        required,
      },
      surname: {
        required,
      },
      email: {
        required,
        email,
      },
      dob: {
        required,
      },
      relation: {
        required,
      },
    };
  },
  computed: {
    ...mapFields("familyMember", [
      "name",
      "surname",
      "email",
      "dob",
      "relation",
    ]),
  },
  methods: {
    save() {
      if (this.v$.$invalid) {
        return;
      }
      if (this.$store.getters["familyMember/id"] == "") {
        this.addFamilyMember();
      } else {
        this.updateFamilyMember();
      }
    },
    addFamilyMember() {
      this.$store.dispatch("familyMember/addFamilyMember").then(
        () => {
          this.$emit("family-done");
          this.$toast.add({
            severity: "success",
            summary: "",
            detail: this.$t("toast.success"),
            life: 3000,
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },

    updateFamilyMember() {
      this.$store.dispatch("familyMember/updateFamilyMember").then(
        () => {
          this.$emit("family-done");
          this.$toast.add({
            severity: "success",
            summary: "",
            detail: this.$t("toast.success"),
            life: 3000,
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
